import { Box, Button, Card, Checkbox, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, InputBase, InputLabel, MenuItem, Paper, Popover, Select, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography, Stepper, StepLabel, Step, IconButton, Tooltip, FormControlLabel, FormGroup } from '@mui/material'
import React, { useEffect, useState, useRef } from 'react'
import { Helmet } from 'react-helmet-async'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import Iconify from 'src/components/iconify'
import PaginationComponent from 'src/components/pagination'
import { deleteData, getData, patchData, postData, putData } from 'src/webService/webService'
import { file_URL } from '../utils/url'

function ConvertedLeads() {

    const [serviceLeads, setServiceLeads] = useState([]);
    const [open, setOpen] = useState("");
    const [selectedLeadId, setSelectedLeadId] = useState(null);
    const [selectedLead, setSelectedLead] = useState(null);
    const [totalCount, setTotalCount] = useState(0);
    const [limit, setLimit] = useState(5);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [formOpen, setFormOpen] = useState(false);

    const sessionToken = sessionStorage.getItem("Token");
    const role = sessionStorage.getItem("role");
    const roleType = sessionStorage.getItem("roleType");

    const [details, setDetails] = useState(false);
    const [scroll, setScroll] = useState('paper');
    const descriptionElementRef = useRef(null);
    const [serviceData, setServiceData] = useState({});
    const [selectedServices, setSelectedServices] = useState([]);
    const [getUserId, setGetUserId] = useState("");
    const [selectedServiceType, setSelectedServiceType] = useState("");
    const [users, setUsers] = useState([])
    const [activeStep, setActiveStep] = useState(0);
    const [paymentOpen, setPaymentOpen] = useState(false);
    const [allPayments, setAllPayments] = useState([]);
    const [totalAmount, setTotalAmount] = useState("");
    const [amountPaid, setAmountPaid] = useState("");
    const [paymentDate, setPaymentDate] = useState("");
    const [paymentMethod, setPaymentMethod] = useState("");
    const [nextPaymentDate, setNextPaymentDate] = useState("");
    const [remainingBalance, setRemainingBalance] = useState('');
    const [paymentId, setPaymentId] = useState('');
    const [paymentStatus, setPaymentStatus] = useState('Add Payment');
    const [gstIncluded, setGstIncluded] = useState(true);
    const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        generalStatus: "New",
        serviceName: [],
        startDate: "",
        duration: "",
        callHistory: "",
        requirements: "",
        assignedUser: "",
        assignedTo: [],
        serviceStatus: "",
        progress: ""
    });

    const serviceOptions = [
        "Content Creation",
        "Camera Man",
        "Video Editing",
        "Graphic Designing",
        "Social Media",
        "SEO",
        "WebSite Designing",
    ];

    const serviceOrder = [
        "Content Creation",
        "Camera Man",
        "Video Editing",
        "Graphic Designing",
        "Social Media",
        "SEO",
        "WebSite Designing"
    ];


    const getOrderedServices = (services) => {
        return services.filter(service => serviceOrder.includes(service))
            .sort((a, b) => serviceOrder.indexOf(a) - serviceOrder.indexOf(b));
    };

    const handleServiceSelection = (selectedValues) => {
        const orderedServices = getOrderedServices(selectedValues);
        setSelectedServices(orderedServices);
        setFormData(prev => ({
            ...prev,
            serviceName: orderedServices
        }));
        getAllUsers(orderedServices);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'shotList') {
            const shotArray = value.split('\n').map((line) => ({
                shotName: line.trim(),
                completed: false
            })).filter(item => item.shotName);
            setServiceData((prev) => ({
                ...prev,
                [name]: shotArray
            }));
        } else {
            setServiceData((prev) => ({
                ...prev,
                [name]: value
            }));
        }
    };

    const handleClose = () => {
        setDetails(false);
        setSelectedLead(null);
    };

    const handleClickFormOpen = () => {
        setFormOpen(true);
        handleCloseMenu();
    };
    const handleClickFormClose = () => {
        setFormOpen(false);
    };

    const handleOpenMenu = (event, id) => {
        const lead = serviceLeads.find((data) => data._id === id);
        if (event?.currentTarget) {
            setOpen(event.currentTarget);
            setSelectedLeadId(id);
            setSelectedLead(lead);
        }
    };

    const handleCloseMenu = () => {
        setOpen(null);
    };

    const handlePaymentOpen = (selectedLead, status) => {
        setPaymentOpen(true);
        setOpen(false);
        setPaymentStatus(status);
        setSelectedLeadId(selectedLead?._id);
        setTotalAmount(selectedLead?.paymentHistory?.totalAmount);
        setRemainingBalance(selectedLead?.paymentHistory?.remainingBalance);
        setPaymentId(selectedLead?.paymentHistory?._id);
    };

    const handlePaymentClose = () => {
        setPaymentOpen(false);
    };

    const handlePayment = async () => {
        debugger
        try {

            const paidAmount = parseFloat(amountPaid) || 0;
            const total = parseFloat(totalAmount) || 0;

            if (paidAmount > total) {
                toast.error("Paid amount cannot exceed total amount");
                return;
            }

            const newRemaining = total - paidAmount;

            const formData = {
                leadId: selectedLeadId,
                totalAmount: total,
                amountPaid: paidAmount,
                paymentDate,
                paymentMethod,
                gstIncluded: gstIncluded,
                paymentStatus: newRemaining === 0 ? "Completed" : "Pending",
                nextPaymentDate: newRemaining > 0 ? nextPaymentDate : null
            }

            if (paymentStatus === "Add Payment") {
                const response = await postData("payments/payment", formData, sessionToken);
                if (response?.status === 200) {
                    setAllPayments(prev => [...prev, response.data]);
                    setPaymentOpen(false);
                    toast.success("Payment Added Successfully!");
                } else {
                    throw new Error(response?.message || "Failed to add Payment.");
                }
            } else {
                const response = await patchData(`payments/payment/${paymentId}`, formData, sessionToken);
                if (response?.status === 200) {
                    setAllPayments(prev =>
                        prev.map(payment =>
                            payment._id === paymentId ? response.data : payment
                        )
                    );
                    setPaymentOpen(false);
                    toast.success("Payment Updated Successfully!");
                } else {
                    throw new Error(response?.message || "Failed to update Payment.");
                }
            }
            await getLeadConvertedToService();
            await getAllPayments();
        } catch (error) {
            console.error("Error:", error);
            toast.error(`Something went wrong. Please try again! ${error ? error : ''}`);
        }
    }

    const getAllPayments = async () => {
        try {
            const response = await getData("payments", {}, sessionToken);
            setAllPayments(response.data.results);
            console.log(response, "Get All Payments");

        } catch (err) {
            console.error("Error while fetching Payment Details:", err);
            toast.error(`Failed to load Payment Details. ${err ? err : ''}`);
        }
    }

    const calculateTotalServiceAmount = () => {
        let total = 0;

        selectedServices.forEach(service => {
            const amountField = getAmountFieldForService(service);
            if (amountField && serviceData[amountField]) {
                total += parseFloat(serviceData[amountField]) || 0;
            }
        });

        return total;
    };

    const getAmountFieldForService = (service) => {
        const fieldMap = {
            "Video Editing": "editingPaidAmount",
            "WebSite Designing": "websitePaidAmount",
            "SEO": "seoAmount",
            "Social Media": "socialMediaPaidAmount",
            "Graphic Designing": "graphicPaidAmount",
            "Content Creation": "contentCreationPaidAmount",
            "Camera Man": "cameraPaidAmount"
        };
        return fieldMap[service];
    };

    const getAllUsers = async (selectedServices) => {
        debugger
        try {
            const params = { page: 1, limit: 1000 }
            const response = await getData("users/users", params);
            console.log("Response:", response);

            const filteredUsers = response.data.results.filter(
                user =>
                    user.role === "Service" &&
                    user.roleType === "Team Leader" &&
                    selectedServices.includes(user.serviceTeamType)
            );

            setUsers(filteredUsers);
        } catch (error) {
            console.error("Error fetching users:", error);
            toast.error(`Failed to load users ${error ? error : ''}`);
        }
    };

    const putService = async () => {
        debugger;
        try {
            const id = getUserId;
            const sessionToken = sessionStorage.getItem("Token");

            if (!sessionToken) {
                toast.error("Authentication Error! Please login again.");
                return;
            }

            const isSocialMediaSelected = selectedServices.includes("Social Media");
            const socialMediaPaymentStatus = isSocialMediaSelected
                ? serviceData.socialPaymentStatus
                : null;

            const putPayload = {
                generalStatus: "Converted",
                serviceName: selectedServices,
                startDate: formData.startDate,
                duration: formData.duration,
                callHistory: formData.callHistory,
                requirements: formData.requirements,
                assignedTo: Array.isArray(formData.assignedTo)
                    ? formData.assignedTo
                    : [formData.assignedTo],
                serviceStatus: "In Progress",
                progress: formData.progress,
                ...(formData.quotationFile && { quotationFileObject: formData.quotationFile })
            };

            const putResponse = await putData(
                `leads/lead/${selectedLeadId}/status`,
                putPayload,
                sessionToken
            );

            if (putResponse.status === 200) {
                if (formData.serviceName?.includes("SEO")) {
                    putPayload.seoType = formData.seoType || null;
                }

                const serviceFieldsMap = {
                    "Video Editing": {
                        fields: ["editingProjectName", "assignedEditor", "editingDeadline", "editingComments", "editingPaymentStatus", "totalEditingShots"],
                        mappings: {
                            assignedEditor: "assignedTo",
                            editingProjectName: "projectName",
                            editingDeadline: "deadline",
                            editingComments: "comments",
                            editingPaidAmount: "amount",
                            editingPaymentStatus: "paymentStatus"
                        }
                    },
                    "WebSite Designing": {
                        fields: ["websiteType", "websiteTotalPages", "websiteSchema", "hostingProvider", "hostingCost", "hostingRenewalDate", "domainProvider", "domainCost", "domainRenewalDate", "maintenanceType", "websiteAssignedTo", "websiteComments", "websiteDeadline", "websitePaidAmount", "websitePaymentStatus"],
                        mappings: {
                            websiteTotalPages: "totalPages",
                            websiteDuration: "duration",
                            WebsiteRequirements: "requirements",
                            websiteAssignedTo: "assignedTo",
                            websiteComments: "comments",
                            websiteDeadline: "deadline",
                            websitePaidAmount: "amount",
                            websitePaymentStatus: "paymentStatus"
                        }
                    },
                    "SEO": {
                        fields: ["seoType", "businessProfileAvailability", "websiteAvailability", "websiteDuration", "businessProfileDuration", "totalKeywords", "targetLocation", "targetKeywords", "seoPackageType", "seoAssignedTo", "seoAmount", "seoPaidAmount", "seoPaymentStatus"],
                        mappings: {
                            seoAssignedTo: "assignedTo",
                            seoAmount: "amount",
                            seoPaidAmount: "paidAmount",
                            seoPaymentStatus: "paymentStatus"
                        }
                    },
                    "Social Media": {
                        fields: ["platform", "postType", "totalPosts", "monthlyPosts", "socialMediaAssignedTo", "socialMediaDeadline", "socialMediaComments", "socialMediaPaidAmount", "socialPaymentStatus"],
                        mappings: {
                            socialMediaAssignedTo: "assignedTo",
                            socialMediaDeadline: "deadline",
                            socialMediaComments: "comments",
                            socialMediaPaidAmount: "amount",
                            socialPaymentStatus: "paymentStatus"
                        }
                    },
                    "Graphic Designing": {
                        fields: ["graphicProjectName", "graphicRequirements", "assignedDesigner", "graphicDeadline", "graphicTotalDesigns", "graphicComments", "graphicPaidAmount", "graphicPaymentStatus"],
                        mappings: {
                            assignedDesigner: "assignedTo",
                            graphicProjectName: "projectName",
                            graphicRequirements: "requirements",
                            graphicDeadline: "deadline",
                            graphicTotalDesigns: "totalDesigns",
                            graphicComments: "comments",
                            graphicPaidAmount: "amount",
                            graphicPaymentStatus: "paymentStatus"
                        }
                    },
                    "Content Creation": {
                        fields: ["contentProjectName", "assignedWriter", "contentCreationDeadline", "contentTotalTasks", "contentComments", "contentCreationPaidAmount", "ccPaymentStatus"],
                        mappings: {
                            assignedWriter: "assignedTo",
                            contentProjectName: "projectName",
                            contentCreationDeadline: "deadline",
                            contentTotalTasks: "totalTasks",
                            contentComments: "comments",
                            contentCreationPaidAmount: "amount",
                            ccPaymentStatus: "paymentStatus"
                        }
                    },
                    "Camera Man": {
                        fields: ["cameraProjectName", "shootType", "location", "assignedPhotographer", "totalShots", "cameraDeadline", "cameraComments", "cameraPaidAmount", "cameraPaymentStatus"],
                        mappings: {
                            cameraProjectName: "projectName",
                            assignedPhotographer: "assignedTo",
                            cameraDeadline: "deadline",
                            cameraComments: "comments",
                            cameraPaidAmount: "amount",
                            cameraPaymentStatus: "paymentStatus"
                        }
                    }
                };

                const totalServiceAmount = calculateTotalServiceAmount();
                const paymentInfo = allPayments.find(p => p.leadId === selectedLeadId);

                // Validation checks
                if (!paymentInfo) {
                    toast.error("No payment record found for this lead. Please add payment first.");
                    return;
                }

                if (totalServiceAmount > paymentInfo.totalAmount) {
                    toast.error(`Total service amount (${totalServiceAmount}) exceeds payment total (${paymentInfo.totalAmount})`);
                    return;
                }

                if (totalServiceAmount > (paymentInfo.totalAmount - paymentInfo.remainingBalance)) {
                    toast.error(`Total service amount (${totalServiceAmount}) exceeds paid amount (${paymentInfo.totalAmount - paymentInfo.remainingBalance})`);
                    return;
                }

                const commonServiceData = {
                    leadId: selectedLeadId,
                    duration: formData.duration || "",
                    progressPercentage: formData.progress || "",
                    clientName: formData.clientName || "",
                    assignedTo: Array.isArray(formData.assignedTo)
                        ? formData.assignedTo
                        : [formData.assignedTo || ""],
                    requirements: formData.requirements || "",
                    // serviceName: Array.isArray(formData.serviceName)
                    //     ? formData.serviceName
                    //     : [formData.serviceName || ""],
                    serviceName: selectedServices
                };

                const servicesPayload = selectedServices
                    .filter(service => serviceFieldsMap[service])
                    .map(service => {
                        const serviceInfo = serviceFieldsMap[service];
                        const servicePayload = {
                            serviceName: service
                        };

                        const isWebsiteDesigning = service === "WebSite Designing";
                        const hasMaintenance = isWebsiteDesigning && !!serviceData.maintenanceType;

                        serviceInfo.fields.forEach(field => {
                            const mappedFieldName = serviceInfo.mappings[field] || field;
                            if (field === "maintenanceType" && !serviceData.maintenanceType) {
                                return;
                            }

                            if (isWebsiteDesigning) {
                                const hostingDomainFields = [
                                    "hostingProvider", "hostingCost", "hostingRenewalDate",
                                    "domainProvider", "domainCost", "domainRenewalDate"
                                ];

                                if (hostingDomainFields.includes(field) && !hasMaintenance) {
                                    return;
                                }
                            }

                            const isShotList = field === 'shotList';
                            servicePayload[mappedFieldName] = isShotList
                                ? (Array.isArray(serviceData[field]) ? serviceData[field] : [])
                                : (serviceData[field] || '');

                            if (isSocialMediaSelected && mappedFieldName === 'paymentStatus') {
                                servicePayload[mappedFieldName] = socialMediaPaymentStatus;
                            }

                        });

                        return servicePayload;
                    });

                const payload = {
                    ...commonServiceData,
                    serviceData: servicesPayload
                };

                const serviceResponse = await postData('leads/services', payload, sessionToken);

                if (!serviceResponse?.data) {
                    throw new Error("Failed to assigned services");
                }

                toast.success(`Service assigned successfully`);

                console.log(payload, "Complete Services Payload");

                setFormOpen(false);
                handleCloseMenu();
                await getLeadConvertedToService();
                toast.success("Service assigned successfully!");
            }
        } catch (error) {
            console.error("Service update error:", error);
            toast.error(`Operation failed: ${error}`);
        }
    };

    useEffect(() => {
        if (selectedServiceType) {
            getAllUsers(selectedServiceType);
        }
        getAllPayments();
    }, [selectedServiceType]);

    const getLeadConvertedToService = async () => {

        const params = {
            page: currentPage,
            limit: limit,
        }

        try {
            console.log("Fetching users...");
            console.log("Token being sent:", sessionToken);

            const response = await getData("leads/services", params, sessionToken);
            console.log("Response:", response)

            const responseData = response.data.results[0].paginatedResults;
            const totalRecords = response.data.results[0].totalCount;

            const LeadId = responseData.length > 0 ? responseData[0]._id : null;

            setGetUserId(LeadId);

            console.log("ResponseData", responseData)

            setServiceLeads(responseData);
            setTotalPages(response.data.results[0].totalPages);
            setTotalCount(totalRecords);
            await getAllPayments();
        } catch (error) {
            console.error("Error fetching users:", error);
        }
    }

    const renderBasicInfoSteps = () => {
        debugger
        return (
            <>
                <FormControl fullWidth margin="dense">
                    <InputLabel>Service Type</InputLabel>
                    <Select
                        multiple
                        name="serviceName"
                        value={selectedServices}
                        onChange={(e) => {
                            let selectedValues = [...e.target.value];
                            if (selectedValues.includes("Social Media") && !selectedValues.includes("Content Creation")) {
                                selectedValues.push("Content Creation");
                            }
                            // Apply ordering immediately
                            const orderedServices = getOrderedServices(selectedValues);
                            setSelectedServices(orderedServices);
                            setFormData(prev => ({
                                ...prev,
                                serviceName: orderedServices
                            }));
                            getAllUsers(orderedServices);
                        }}
                        renderValue={(selected) => getOrderedServices(selected).join(", ")}
                    >
                        {serviceOptions.map((service) => (
                            <MenuItem key={service} value={service}>
                                <Checkbox checked={selectedServices.includes(service)} />
                                <Typography>{service}</Typography>
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                {selectedServices.includes("Social Media") && (
                    <FormControl margin="dense" fullWidth>
                        <InputLabel>Post Type</InputLabel>
                        <Select
                            label="Post Type"
                            name="postType"
                            multiple
                            required
                            value={serviceData.postType || []}
                            onChange={(e) => {
                                let selectedPostTypes = e.target.value;

                                // Sync PostType selection
                                setServiceData(prev => ({
                                    ...prev,
                                    postType: selectedPostTypes
                                }));

                                // Add related services automatically
                                let updatedServices = [...selectedServices];

                                if (selectedPostTypes.includes("Video") || selectedPostTypes.includes("Reel")) {
                                    if (!updatedServices.includes("Camera Man")) {
                                        updatedServices.push("Camera Man");
                                    }
                                    if (!updatedServices.includes("Video Editing")) {
                                        updatedServices.push("Video Editing");
                                    }
                                }

                                if (selectedPostTypes.includes("Poster")) {
                                    if (!updatedServices.includes("Graphic Designing")) {
                                        updatedServices.push("Graphic Designing");
                                    }
                                }

                                setSelectedServices(updatedServices);
                                setServiceData(prev => ({
                                    ...prev,
                                    serviceName: updatedServices
                                }));
                                getAllUsers(updatedServices);
                            }}
                            renderValue={(selected) =>
                                Array.isArray(selected) ? selected.join(", ") : ""
                            }
                        >
                            {["Reel", "Poster"].map(
                                (type) => (
                                    <MenuItem key={type} value={type}>
                                        {type}
                                    </MenuItem>
                                )
                            )}
                        </Select>
                    </FormControl>
                )}
                <FormControl fullWidth margin="dense">
                    <InputLabel>Assigned Users</InputLabel>
                    <Select
                        multiple
                        name="assignedTo"
                        value={Array.isArray(formData.assignedTo) ? formData.assignedTo : []}
                        onChange={(e) => {
                            const selectedValues = e.target.value;
                            setFormData(prev => ({
                                ...prev,
                                assignedTo: Array.isArray(selectedValues) ? selectedValues : [selectedValues]
                            }));
                        }}
                        renderValue={(selected) => {
                            if (!selected || selected.length === 0) return <em>No users selected</em>;
                            return selected.map(userId => {
                                const user = users.find(u => u._id === userId);
                                return user ? user.name : "";
                            }).join(", ");
                        }}
                    >
                        {users.map((user) => (
                            <MenuItem key={user._id} value={user._id}>
                                <Checkbox checked={formData.assignedTo?.includes(user._id) || false} />
                                <Typography>{`${user.name} (${user.role} - ${user.roleType})`}</Typography>
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </>
        )
    }

    const renderServiceStep = (service) => {

        const serviceTeamLeaders = users.filter(user =>
            user.serviceTeamType === service
        )

        const isSocialMediaSelected = selectedServices.includes("Social Media");

        switch (service) {
            case "Content Creation":
                return (
                    <>
                        <TextField margin="dense" label="Project Name" name="contentProjectName" value={serviceData.contentProjectName || ''} onChange={handleChange} fullWidth />

                        <FormControl fullWidth margin="dense">
                            <InputLabel>Assigned Writer</InputLabel>
                            <Select
                                name="assignedWriter"
                                value={serviceData.assignedWriter}
                                // value={Array.isArray(formData.assignedTo) ? formData.assignedTo : [] && serviceData.assignedWriter}
                                onChange={handleChange}
                                label="Assigned Writer"
                            >
                                {serviceTeamLeaders.map((user) => (
                                    <MenuItem key={user._id} value={user._id}>
                                        {user.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <TextField margin="dense" label="Deadline" name="contentCreationDeadline" type="date" InputLabelProps={{ shrink: true }} value={serviceData.contentCreationDeadline || ''} onChange={handleChange} fullWidth />
                        <TextField margin="dense" type="number" label="Total Tasks" name="contentTotalTasks" value={serviceData.contentTotalTasks || ''} onChange={handleChange} fullWidth />
                        <TextField margin="dense" label="Comments" name="contentComments" value={serviceData.contentComments || ''} onChange={handleChange} fullWidth multiline />
                        {
                            !isSocialMediaSelected && (
                                <>
                                    <TextField
                                        margin='dense'
                                        label="Amount"
                                        name={getAmountFieldForService(service)}
                                        value={serviceData[getAmountFieldForService(service)] || ''}
                                        onChange={(e) => {
                                            const paymentInfo = allPayments.find(p => p.leadId === selectedLeadId);
                                            const newAmount = parseFloat(e.target.value) || 0;

                                            if (paymentInfo && newAmount > paymentInfo.totalAmount) {
                                                toast.error(`Amount exceeds payment total (${paymentInfo.totalAmount})`);
                                                return;
                                            }

                                            handleChange(e);
                                        }}
                                        type="number"
                                        fullWidth
                                    />
                                    <TextField margin="dense" select label="Payment Status" name="ccPaymentStatus" value={serviceData.ccPaymentStatus || ''} onChange={handleChange} fullWidth>
                                        {["Pending", "Completed"].map(p => (
                                            <MenuItem key={p} value={p}>{p}</MenuItem>
                                        ))}
                                    </TextField>
                                </>
                            )
                        }
                    </>
                )
            case "Camera Man":
                return (
                    <>
                        <TextField margin="dense" label="Project Name" name="cameraProjectName" value={serviceData.cameraProjectName || ''} onChange={handleChange} fullWidth />
                        <TextField
                            margin="dense"
                            label="Shoot Type"
                            name="shootType"
                            value={serviceData.shootType || ""}
                            onChange={handleChange}
                            fullWidth
                        />
                        <TextField margin="dense" label="Location" name="location" value={serviceData.location || ''} onChange={handleChange} fullWidth />
                        <FormControl fullWidth margin="dense">
                            <InputLabel>Assigned Photographer</InputLabel>
                            <Select
                                name="assignedPhotographer"
                                value={serviceData.assignedPhotographer}
                                onChange={handleChange}
                                label="Assigned Photographer"
                                SelectProps={{
                                    multiple: true,
                                    renderValue: (selected) => Array.isArray(selected) ? selected.join(', ') : ''
                                }}
                            >
                                {serviceTeamLeaders.map((user) => (
                                    <MenuItem key={user._id} value={user._id}>
                                        {user.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl><TextField margin="dense" label="Deadline" name="cameraDeadline" type="date" InputLabelProps={{ shrink: true }} value={serviceData.cameraDeadline || ''} onChange={handleChange} fullWidth />
                        <TextField margin="dense" label="Comments" name="cameraComments" value={serviceData.cameraComments || ''} onChange={handleChange} fullWidth multiline />
                        <TextField
                            margin="dense"
                            label="Total Videos"
                            name="totalShots"
                            type="number"
                            value={serviceData.totalShots || ''}
                            onChange={handleChange}
                            fullWidth
                        />
                        {
                            !isSocialMediaSelected && (
                                <>
                                    <TextField
                                        margin='dense'
                                        label="Amount"
                                        name={getAmountFieldForService(service)}
                                        value={serviceData[getAmountFieldForService(service)] || ''}
                                        onChange={(e) => {
                                            const paymentInfo = allPayments.find(p => p.leadId === selectedLeadId);
                                            const newAmount = parseFloat(e.target.value) || 0;

                                            if (paymentInfo && newAmount > paymentInfo.totalAmount) {
                                                toast.error(`Amount exceeds payment total (${paymentInfo.totalAmount})`);
                                                return;
                                            }

                                            handleChange(e);
                                        }}
                                        type="number"
                                        fullWidth
                                    />
                                    <TextField margin="dense" select label="Payment Status" name="cameraPaymentStatus" value={serviceData.cameraPaymentStatus || ''} onChange={handleChange} fullWidth>
                                        {["Pending", "Completed"].map(p => (
                                            <MenuItem key={p} value={p}>{p}</MenuItem>
                                        ))}
                                    </TextField>
                                </>
                            )
                        }
                    </>
                )
            case "Video Editing":
                return (
                    <>
                        <TextField margin="dense" label="Project Name" name="editingProjectName" value={serviceData.editingProjectName || ''} onChange={handleChange} fullWidth />
                        <FormControl fullWidth margin="dense">
                            <InputLabel>Assigned Editor</InputLabel>
                            <Select
                                name="assignedEditor"
                                value={serviceData.assignedEditor}
                                onChange={handleChange}
                                label="Assigned Editor"
                            >
                                {serviceTeamLeaders.map((user) => (
                                    <MenuItem key={user._id} value={user._id}>
                                        {user.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <TextField
                            margin="dense"
                            label="Total Tasks"
                            name="totalEditingShots"
                            type="number"
                            value={serviceData.totalEditingShots || ''}
                            onChange={handleChange}
                            fullWidth
                        />
                        <TextField margin="dense" label="Deadline" name="editingDeadline" type="date" InputLabelProps={{ shrink: true }} value={serviceData.editingDeadline || ''} onChange={handleChange} fullWidth />
                        <TextField margin="dense" label="Comments" name="editingComments" value={serviceData.editingComments || ''} onChange={handleChange} fullWidth multiline />
                        {
                            !isSocialMediaSelected && (
                                <>
                                    <TextField
                                        margin='dense'
                                        label="Amount"
                                        name={getAmountFieldForService(service)}
                                        value={serviceData[getAmountFieldForService(service)] || ''}
                                        onChange={(e) => {
                                            const paymentInfo = allPayments.find(p => p.leadId === selectedLeadId);
                                            const newAmount = parseFloat(e.target.value) || 0;

                                            if (paymentInfo && newAmount > paymentInfo.totalAmount) {
                                                toast.error(`Amount exceeds payment total (${paymentInfo.totalAmount})`);
                                                return;
                                            }

                                            handleChange(e);
                                        }}
                                        type="number"
                                        fullWidth
                                    />
                                    <TextField margin="dense" select label="Payment Status" name="editingPaymentStatus" value={serviceData.editingPaymentStatus || ''} onChange={handleChange} fullWidth>
                                        {["Pending", "Completed"].map(p => (
                                            <MenuItem key={p} value={p}>{p}</MenuItem>
                                        ))}
                                    </TextField>
                                </>
                            )
                        }
                    </>
                )
            case "Social Media":
                return (
                    <>
                        <TextField
                            margin="dense"
                            select
                            label="Platform"
                            name="platform"
                            value={serviceData.platform || []}
                            onChange={handleChange}
                            fullWidth
                            required
                            SelectProps={{
                                multiple: true,
                                renderValue: (selected) => Array.isArray(selected) ? selected.join(', ') : ''
                            }}
                        >
                            {["Facebook", "Instagram", "Twitter", "LinkedIn", "YouTube", "TikTok"].map(p => (
                                <MenuItem key={p} value={p}>{p}</MenuItem>
                            ))}
                        </TextField>
                        <TextField
                            margin="dense"
                            select
                            label="Post Type"
                            name="postType"
                            required
                            value={serviceData.postType || []}
                            onChange={handleChange}
                            fullWidth
                            SelectProps={{
                                multiple: true,
                                renderValue: (selected) => Array.isArray(selected) ? selected.join(', ') : ''
                            }}
                        >
                            {["Image", "Video", "Text", "Story", "Reel", "Ad", "Poster"].map(type => (
                                <MenuItem key={type} value={type}>{type}</MenuItem>
                            ))}
                        </TextField>
                        <TextField
                            margin="dense"
                            label="Total Posts"
                            name="totalPosts"
                            type="number"
                            required
                            value={serviceData.totalPosts || ''}
                            onChange={handleChange}
                            fullWidth
                        />
                        <TextField
                            margin="dense"
                            label="No of Reels / Months"
                            name="monthlyPosts"
                            type="number"
                            required
                            value={serviceData.monthlyPosts || ''}
                            onChange={handleChange}
                            fullWidth
                        />
                        <FormControl fullWidth margin="dense">
                            <InputLabel required>Assigned To</InputLabel>
                            <Select
                                name="socialMediaAssignedTo"
                                value={serviceData.socialMediaAssignedTo}
                                onChange={handleChange}
                                label="Assigned To"
                                SelectProps={{
                                    multiple: true,
                                    renderValue: (selected) => Array.isArray(selected) ? selected.join(', ') : ''
                                }}
                            >
                                {serviceTeamLeaders.map((user) => (
                                    <MenuItem key={user._id} value={user._id}>
                                        {user.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <TextField margin="dense" label="Deadline" name="socialMediaDeadline" type="date" required InputLabelProps={{ shrink: true }} value={serviceData.socialMediaDeadline || ''} onChange={handleChange} fullWidth />
                        <TextField margin="dense" label="Comments" name="socialMediaComments" value={serviceData.socialMediaComments || ''} onChange={handleChange} fullWidth multiline />
                        <TextField
                            margin='dense'
                            label="Amount"
                            required
                            name={getAmountFieldForService(service)}
                            value={serviceData[getAmountFieldForService(service)] || ''}
                            onChange={(e) => {
                                const paymentInfo = allPayments.find(p => p.leadId === selectedLeadId);
                                const newAmount = parseFloat(e.target.value) || 0;

                                if (paymentInfo && newAmount > paymentInfo.totalAmount) {
                                    toast.error(`Amount exceeds payment total (${paymentInfo.totalAmount})`);
                                    return;
                                }

                                handleChange(e);
                            }}
                            type="number"
                            fullWidth
                        />
                        <TextField required margin="dense" select label="Payment Status" name="socialPaymentStatus" value={serviceData.socialPaymentStatus || ''} onChange={handleChange} fullWidth>
                            {["Pending", "Completed"].map(p => (
                                <MenuItem key={p} value={p}>{p}</MenuItem>
                            ))}
                        </TextField>
                    </>
                )
            case "WebSite Designing":
                return (
                    <>
                        <TextField margin="dense" select label="Website Type" name="websiteType" value={serviceData.websiteType || ''} onChange={handleChange} required fullWidth>
                            <MenuItem value="E-Commerce">E-Commerce</MenuItem>
                            <MenuItem value="Normal">Normal</MenuItem>
                            <MenuItem value="Single-Landing-Page">Single-Landing-Page</MenuItem>
                        </TextField>
                        <TextField margin="dense" type='number' label="Total Pages" name="websiteTotalPages" value={serviceData.websiteTotalPages || ''} onChange={handleChange} required fullWidth />
                        <FormControl fullWidth margin="dense">
                            <InputLabel>Assigned To</InputLabel>
                            <Select
                                name="websiteAssignedTo"
                                value={serviceData.websiteAssignedTo}
                                onChange={handleChange}
                                label="Assigned To"
                            >
                                {serviceTeamLeaders.map((user) => (
                                    <MenuItem key={user._id} value={user._id}>
                                        {user.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <TextField margin="dense" label="Comments" name="websiteComments" value={serviceData.websiteComments || ''} onChange={handleChange} fullWidth multiline />
                        <TextField margin="dense" label="Deadline" name="websiteDeadline" type="date" InputLabelProps={{ shrink: true }} value={serviceData.websiteDeadline || ''} onChange={handleChange} required fullWidth />
                        <TextField
                            margin='dense'
                            label="Amount"
                            name={getAmountFieldForService(service)}
                            value={serviceData[getAmountFieldForService(service)] || ''}
                            onChange={(e) => {
                                const paymentInfo = allPayments.find(p => p.leadId === selectedLeadId);
                                const newAmount = parseFloat(e.target.value) || 0;

                                if (paymentInfo && newAmount > paymentInfo.totalAmount) {
                                    toast.error(`Amount exceeds payment total (${paymentInfo.totalAmount})`);
                                    return;
                                }

                                handleChange(e);
                            }}
                            type="number"
                            fullWidth
                        />
                        <TextField margin="dense" select label="Payment Status" name="websitePaymentStatus" value={serviceData.websitePaymentStatus || ''} onChange={handleChange} fullWidth>
                            {["Pending", "Completed"].map(p => (
                                <MenuItem key={p} value={p}>{p}</MenuItem>
                            ))}
                        </TextField>
                        <TextField
                            margin="dense"
                            select
                            label="Domain & Maintenance"
                            name="websiteSchema"
                            value={serviceData.websiteSchema || []}
                            onChange={handleChange}
                            fullWidth
                            SelectProps={{
                                multiple: true,
                                renderValue: (selected) => Array.isArray(selected) ? selected.join(', ') : ''
                            }}
                        >
                            <MenuItem value="Hosting">Hosting</MenuItem>
                            <MenuItem value="Domain">Domain</MenuItem>
                            <MenuItem value="Website Maintenance">Website Maintenance</MenuItem>
                        </TextField>
                        {(serviceData.websiteSchema?.includes("Hosting")) && (
                            <>
                                <FormControl fullWidth margin="dense">
                                    <InputLabel>Hosting Provider</InputLabel>
                                    <Select
                                        name="hostingProvider"
                                        value={serviceData.hostingProvider || ''}
                                        onChange={handleChange}
                                        label="Hosting Provider"
                                    >
                                        <MenuItem value="Self">Self (Our Company)</MenuItem>
                                        <MenuItem value="Client">Client Side</MenuItem>
                                    </Select>
                                </FormControl>

                                <TextField
                                    margin="dense"
                                    label="Hosting Renewal Date"
                                    name="hostingRenewalDate"
                                    type="date"
                                    InputLabelProps={{ shrink: true }}
                                    value={serviceData.hostingRenewalDate || ''}
                                    onChange={handleChange}
                                    fullWidth
                                />

                                {(serviceData.hostingProvider?.includes('Self')) && (
                                    <TextField
                                        margin='dense'
                                        label='Hosting Cost'
                                        name='hostingCost'
                                        InputLabelProps={{ shrink: true }}
                                        value={serviceData.hostingCost || ''}
                                        onChange={handleChange}
                                        fullWidth
                                    />
                                )}
                            </>
                        )}

                        {(serviceData.websiteSchema?.includes("Domain")) && (
                            <>
                                <FormControl fullWidth margin="dense">
                                    <InputLabel>Domain Provider</InputLabel>
                                    <Select
                                        name="domainProvider"
                                        value={serviceData.domainProvider || ''}
                                        onChange={handleChange}
                                        label="Domain Provider"
                                    >
                                        <MenuItem value="Self">Self (Our Company)</MenuItem>
                                        <MenuItem value="Client">Client Side</MenuItem>
                                    </Select>
                                </FormControl>

                                <TextField
                                    margin="dense"
                                    label="Domain Renewal Date"
                                    name="domainRenewalDate"
                                    type="date"
                                    InputLabelProps={{ shrink: true }}
                                    value={serviceData.domainRenewalDate || ''}
                                    onChange={handleChange}
                                    fullWidth
                                />

                                {(serviceData.domainProvider?.includes('Self')) && (
                                    <TextField
                                        margin='dense'
                                        label='Domain Cost'
                                        name='domainCost'
                                        InputLabelProps={{ shrink: true }}
                                        value={serviceData.domainCost || ''}
                                        onChange={handleChange}
                                        fullWidth
                                    />
                                )}
                            </>
                        )}

                        {serviceData.websiteSchema?.includes("Website Maintenance") && (
                            <FormControl fullWidth margin="dense">
                                <InputLabel>Maintenance Type</InputLabel>
                                <Select
                                    name="maintenanceType"
                                    value={serviceData.maintenanceType || ''}
                                    onChange={handleChange}
                                    label="Maintenance Type"
                                >
                                    <MenuItem value="Included">Included</MenuItem>
                                    <MenuItem value="Excluded">Excluded</MenuItem>
                                </Select>
                            </FormControl>
                        )}
                    </>
                )
            case "Graphic Designing":
                return (
                    <>
                        <TextField margin="dense" label="Project Name" name="graphicProjectName" value={serviceData.graphicProjectName || ''} onChange={handleChange} fullWidth />
                        <TextField margin="dense" label="Requirements" name="graphicRequirements" value={serviceData.graphicRequirements || ''} onChange={handleChange} fullWidth multiline />
                        <FormControl fullWidth margin="dense">
                            <InputLabel>Assigned Designer</InputLabel>
                            <Select
                                name="assignedDesigner"
                                value={serviceData.assignedDesigner}
                                onChange={handleChange}
                                label="Assigned Designer"
                            >
                                {serviceTeamLeaders.map((user) => (
                                    <MenuItem key={user._id} value={user._id}>
                                        {user.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <TextField margin="dense" label="Deadline" name="graphicDeadline" type="date" InputLabelProps={{ shrink: true }} value={serviceData.graphicDeadline || ''} onChange={handleChange} fullWidth />
                        <TextField margin="dense" type='number' label="Total Designs" name="graphicTotalDesigns" value={serviceData.graphicTotalDesigns || ''} onChange={handleChange} fullWidth />
                        <TextField margin="dense" label="Comments" name="graphicComments" value={serviceData.graphicComments || ''} onChange={handleChange} fullWidth multiline />
                        {
                            !isSocialMediaSelected && (
                                <>
                                    <TextField
                                        margin='dense'
                                        label="Amount"
                                        name={getAmountFieldForService(service)}
                                        value={serviceData[getAmountFieldForService(service)] || ''}
                                        onChange={(e) => {
                                            const paymentInfo = allPayments.find(p => p.leadId === selectedLeadId);
                                            const newAmount = parseFloat(e.target.value) || 0;

                                            if (paymentInfo && newAmount > paymentInfo.totalAmount) {
                                                toast.error(`Amount exceeds payment total (${paymentInfo.totalAmount})`);
                                                return;
                                            }

                                            handleChange(e);
                                        }}
                                        type="number"
                                        fullWidth
                                    />
                                    <TextField margin="dense" select label="Payment Status" name="graphicPaymentStatus" value={serviceData.graphicPaymentStatus || ''} onChange={handleChange} fullWidth>
                                        {["Pending", "Completed"].map(p => (
                                            <MenuItem key={p} value={p}>{p}</MenuItem>
                                        ))}
                                    </TextField>
                                </>
                            )
                        }
                    </>
                )
            case "SEO":
                return (
                    <>
                        <TextField
                            margin="dense"
                            select
                            label="SEO Type"
                            name="seoType"
                            required
                            value={serviceData.seoType || []}
                            onChange={handleChange}
                            fullWidth
                            SelectProps={{
                                multiple: true,
                                renderValue: (selected) => Array.isArray(selected) ? selected.join(', ') : ''
                            }}
                        >
                            <MenuItem value="Google Business Profile">Google Business Profile</MenuItem>
                            <MenuItem value="Website SEO">Website SEO</MenuItem>
                        </TextField>
                        <TextField margin="dense" select label="Business Profile Availability" name="businessProfileAvailability" value={serviceData.businessProfileAvailability || ''} onChange={handleChange} required fullWidth>
                            <MenuItem value="Yes">Yes</MenuItem>
                            <MenuItem value="No">No</MenuItem>
                        </TextField>
                        <TextField margin="dense" select label="Website Availability" name="websiteAvailability" value={serviceData.websiteAvailability || ''} onChange={handleChange} required fullWidth>
                            <MenuItem value="Yes">Yes</MenuItem>
                            <MenuItem value="No">No</MenuItem>
                        </TextField>
                        <TextField margin="dense" label="Website SEO Duration" name="websiteDuration" type="date" InputLabelProps={{ shrink: true }} value={serviceData.websiteDuration || ''} onChange={handleChange} required fullWidth />
                        <TextField margin="dense" label="Business Profile Duration" name="businessProfileDuration" type="date" InputLabelProps={{ shrink: true }} value={serviceData.businessProfileDuration || ''} onChange={handleChange} required fullWidth />
                        <TextField margin="dense" label="Target Location" name="targetLocation" value={serviceData.targetLocation || ''} onChange={handleChange} required fullWidth />
                        <TextField margin="dense" label="Target Keywords" name="targetKeywords" value={serviceData.targetKeywords || ''} onChange={handleChange} fullWidth />
                        <TextField margin="dense" select label="Package Type" name="seoPackageType" value={serviceData.seoPackageType || ''} onChange={handleChange} required fullWidth>
                            <MenuItem value="3 months">3 Months</MenuItem>
                            <MenuItem value="4 months">4 Months</MenuItem>
                            <MenuItem value="6 months">6 Months</MenuItem>
                            <MenuItem value="1 year">1 Year</MenuItem>
                        </TextField>
                        <TextField
                            margin="dense"
                            label="Total Keywords"
                            name="totalKeywords"
                            type="number"
                            required
                            value={serviceData.totalKeywords || ''}
                            onChange={handleChange}
                            fullWidth
                        />
                        <FormControl fullWidth margin="dense">
                            <InputLabel required>Assigned To</InputLabel>
                            <Select
                                name="seoAssignedTo"
                                value={serviceData.seoAssignedTo}
                                onChange={handleChange}
                                label="Assigned To"
                                required
                            >
                                {serviceTeamLeaders.map((user) => (
                                    <MenuItem key={user._id} value={user._id}>
                                        {user.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <TextField required margin='dense' label="Total Amount" name='seoTotalAmount' value={serviceData.seoTotalAmount} onChange={handleChange} fullWidth />
                        <TextField
                            required
                            margin='dense'
                            label="Amount"
                            name={getAmountFieldForService(service)}
                            value={serviceData[getAmountFieldForService(service)] || ''}
                            onChange={(e) => {
                                const paymentInfo = allPayments.find(p => p.leadId === selectedLeadId);
                                const newAmount = parseFloat(e.target.value) || 0;

                                if (paymentInfo && newAmount > paymentInfo.totalAmount) {
                                    toast.error(`Amount exceeds payment total (${paymentInfo.totalAmount})`);
                                    return;
                                }

                                handleChange(e);
                            }}
                            type="number"
                            fullWidth
                        />
                        <TextField required margin="dense" select label="Payment Status" name="seoPaymentStatus" value={serviceData.seoPaymentStatus || ''} onChange={handleChange} fullWidth>
                            {["Pending", "Completed"].map(p => (
                                <MenuItem key={p} value={p}>{p}</MenuItem>
                            ))}
                        </TextField>
                    </>
                )
            default:
                return null;
        }
    }

    const handleNext = () => {
        console.log("Current step:", activeStep);
        console.log("Selected services:", selectedServices);
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const isLastStep = () => {
        return activeStep === getOrderedServices(selectedServices).length;
    };

    useEffect(() => {
        getLeadConvertedToService(currentPage, limit);
    }, [currentPage, limit])

    const handleDelete = async (id) => {
        debugger;
        if (!id) {
            console.error("User ID is undefined.");
            return;
        }
        try {
            const response = await deleteData(`leads/lead/${id}`, sessionToken);
            console.log(response.message);
            toast.success("User deleted successfully!");
            setServiceLeads((prevUsers) => prevUsers.filter((user) => user.id !== id));
        } catch (error) {
            console.error("Error deleting user:", error);
            toast.error(`${error ? error : ''}`);
        }
        await getLeadConvertedToService();
    };

    const handleLimitChange = (event) => {
        setCurrentPage(1);
        if (currentPage === 1) {
            setLimit(event.target.value)
            getLeadConvertedToService(1, event.target.value)
        }
        else {
            setCurrentPage(1);
            setLimit(event.target.value);
        }
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage((prev) => prev - 1);
            getLeadConvertedToService(currentPage - 1, limit);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage((prev) => prev + 1);
            getLeadConvertedToService(currentPage + 1, limit);
        }
    };

    const calculateIndex = (index) => {
        return (currentPage - 1) * limit + index + 1;
    };

    const handleViewClick = () => {
        navigate(`/admin/view-details/${selectedLeadId}`)
    }

    return (
        <>
            <Helmet>
                <title>Converted Leads</title>
            </Helmet>
            <Container>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                    <Typography variant="h4" gutterBottom>
                        Converted Leads
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "start",
                                backgroundColor: "white",
                                borderRadius: "15px",
                                padding: "4px 12px",
                                boxShadow: 1,
                                marginRight: "20px"
                            }}
                        >
                            <Iconify icon="eva:search-fill" />
                            <InputBase
                                placeholder="Search"
                                sx={{ marginLeft: "8px" }}
                            />
                        </Box>
                    </Box>
                </Stack>

                <Card sx={{ padding: 2, boxShadow: 3, backgroundColor: "#fff" }}>
                    <TableContainer component={Paper} sx={{ boxShadow: "none", backgroundColor: "transparent", maxHeight: 350 }}>
                        <Table>
                            <TableHead>
                                <TableCell>S.No</TableCell>
                                <TableCell>Lead Name</TableCell>
                                <TableCell>Contact</TableCell>
                                <TableCell>Payment Status</TableCell>
                                <TableCell>Total Amount</TableCell>
                                <TableCell>Remaining Balance</TableCell>
                                <TableCell>Next Payment</TableCell>
                                <TableCell>Quotation</TableCell>
                                <TableCell></TableCell>
                            </TableHead>
                            <TableBody>
                                {serviceLeads.map((lead, id) => (
                                    <TableRow key={lead?.id}>
                                        <TableCell>{calculateIndex(id)}</TableCell>
                                        <TableCell>
                                            <Typography variant="caption">
                                                {lead?.name}
                                            </Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Typography variant='caption'>
                                                {lead?.phone}
                                            </Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Typography variant='caption'>{lead?.paymentHistory?.paymentStatus ? lead?.paymentHistory?.paymentStatus : "-"}</Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Typography variant='caption'>{lead?.paymentHistory?.totalAmount ? lead?.paymentHistory?.totalAmount : "-"}</Typography><br />
                                            {lead?.paymentHistory && (
                                                <Typography variant='caption' color="textSecondary">
                                                    {lead?.paymentHistory?.gstIncluded === true ? "(+ GST)" : "(No GST)"}
                                                </Typography>
                                            )}
                                        </TableCell>
                                        <TableCell>
                                            <Typography variant='caption'>{lead?.paymentHistory?.remainingBalance === 0 ? "-" : lead?.paymentHistory?.remainingBalance}</Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Typography variant='caption'>
                                                {lead?.paymentHistory?.nextPaymentDate === null ? "-" :
                                                    new Date(lead?.paymentHistory?.nextPaymentDate).toLocaleDateString('en-GB', {
                                                        day: '2-digit',
                                                        month: '2-digit',
                                                        year: '2-digit'
                                                    })
                                                }
                                            </Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Tooltip title="View Quotation File">
                                                <IconButton
                                                    href={
                                                        lead?.serviceHistory[lead?.serviceHistory.length - 1]?.quotationFileObject?.path
                                                            ? `${file_URL + encodeURI(lead?.serviceHistory[lead?.serviceHistory.length - 1]?.quotationFileObject?.path.replace("public/", ""))}`
                                                            : "#"
                                                    }
                                                    target='_blank'
                                                >
                                                    <Iconify icon="mdi:file-document-outline" />
                                                </IconButton>
                                            </Tooltip>
                                        </TableCell>
                                        <TableCell>
                                            <Iconify icon="material-symbols-light:more-vert" sx={{ margin: "auto" }} onClick={(event) => handleOpenMenu(event, lead._id)} />
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <PaginationComponent
                        name={"Converted Leads"}
                        totalcount={totalCount}
                        limit={limit}
                        handleLimitChange={handleLimitChange}
                        handlePrevPage={handlePrevPage}
                        handleNextPage={handleNextPage}
                        currentPage={currentPage}
                        totalPages={totalPages}
                    />
                    <Popover
                        open={Boolean(open)}
                        anchorEl={open}
                        onClose={handleCloseMenu}
                        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                        PaperProps={{
                            sx: {
                                p: 1,
                                width: 175,
                                '& .MuiMenuItem-root': {
                                    px: 1,
                                    typography: 'body2',
                                    borderRadius: 0.75,
                                },
                            },
                        }}
                    >
                        {role === "Admin" ? (
                            <>
                                <MenuItem onClick={handleClickFormOpen}>
                                    <Iconify icon="material-symbols:person-add" sx={{ mr: 2 }} />
                                    Onboard
                                </MenuItem>
                                <MenuItem onClick={handleViewClick}>
                                    <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
                                    View
                                </MenuItem>
                                <MenuItem onClick={() => {
                                    const currentPayment = allPayments?.find(p => p.leadId === selectedLeadId);
                                    handlePaymentOpen(selectedLead, currentPayment ? "Update Payment" : "Add Payment");
                                }}>
                                    <Iconify icon={'material-symbols:currency-rupee'} sx={{ mr: 1 }} />
                                    {allPayments?.some(p => p.leadId === selectedLeadId) ? "Update Payment" : "Add Payment"}
                                </MenuItem>

                                <MenuItem sx={{ color: 'error.main' }}
                                    onClick={() => {
                                        if (!selectedLeadId) {
                                            toast.error('No user selected. Please try again.');
                                            return;
                                        }
                                        const confirmDelete = window.confirm('Are you sure you want to delete this user?');
                                        if (confirmDelete) {
                                            handleDelete(selectedLeadId);
                                            handleCloseMenu();
                                        }
                                    }}
                                >
                                    <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
                                    Delete
                                </MenuItem>
                            </>
                        ) : roleType === "Team Leader" ? (
                            <>
                                <MenuItem onClick={handleViewClick}>
                                    <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
                                    View
                                </MenuItem>
                                <MenuItem onClick={() => {
                                    const currentPayment = allPayments?.find(p => p.leadId === selectedLeadId);
                                    handlePaymentOpen(selectedLead, currentPayment ? "Update Payment" : "Add Payment");
                                }}>
                                    <Iconify icon={'material-symbols:currency-rupee'} sx={{ mr: 1 }} />
                                    {allPayments?.some(p => p.leadId === selectedLeadId) ? "Update Payment" : "Add Payment"}
                                </MenuItem>

                                <MenuItem sx={{ color: 'error.main' }}
                                    onClick={() => {
                                        if (!selectedLeadId) {
                                            toast.error('No user selected. Please try again.');
                                            return;
                                        }
                                        const confirmDelete = window.confirm('Are you sure you want to delete this user?');
                                        if (confirmDelete) {
                                            handleDelete(selectedLeadId);
                                            handleCloseMenu();
                                        }
                                    }}
                                >
                                    <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
                                    Delete
                                </MenuItem>
                            </>
                        ) : (
                            <>
                                <MenuItem onClick={() => {
                                    const currentPayment = allPayments?.find(p => p.leadId === selectedLeadId);
                                    handlePaymentOpen(selectedLead, currentPayment ? "Update Payment" : "Add Payment");
                                }}>
                                    <Iconify icon={'material-symbols:currency-rupee'} sx={{ mr: 1 }} />
                                    {allPayments?.some(p => p.leadId === selectedLeadId) ? "Update Payment" : "Add Payment"}
                                </MenuItem>
                                <MenuItem sx={{ color: 'error.main' }}
                                    onClick={() => {
                                        if (!selectedLeadId) {
                                            toast.error('No user selected. Please try again.');
                                            return;
                                        }
                                        const confirmDelete = window.confirm('Are you sure you want to delete this user?');
                                        if (confirmDelete) {
                                            handleDelete(selectedLeadId);
                                            handleCloseMenu();
                                        }
                                    }}
                                >
                                    <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
                                    Delete
                                </MenuItem>
                            </>
                        )}
                    </Popover>
                </Card>
                <Dialog
                    open={details}
                    onClose={handleClose}
                    scroll={scroll}
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"
                >
                    <DialogTitle id="scroll-dialog-title">Converted Leads Details</DialogTitle>
                    <DialogContent dividers={scroll === 'paper'}>
                        <DialogContentText
                            id="scroll-dialog-description"
                            ref={descriptionElementRef}
                        // tabIndex={-1}
                        >
                            {selectedLead ? (
                                <>
                                    {/* <p><strong>Id:</strong> {selectedLead._id}</p> */}
                                    <p><strong>Name:</strong> {selectedLead?.name}</p>
                                    <p><strong>Phone:</strong> {selectedLead?.phone}</p>
                                    <p><strong>Email:</strong> {selectedLead?.email}</p>
                                    <p><strong>Company:</strong> {selectedLead?.company}</p>
                                    <p><strong>General Status:</strong> {selectedLead?.generalStatus}</p>
                                    <p><strong>Assigned User:</strong> {selectedLead?.assignedTo?.name} { }</p>
                                    <p><strong>Status History:</strong> {selectedLead?.statusHistory[0]?.status}</p>
                                    {/* <p><strong>Updated At:</strong> {selectedLead.statusHistory[0]?.updatedAt}</p> */}
                                    {/* <p><strong>Service Name:</strong> {selectedLead.serviceHistory[0].serviceName}</p> */}
                                    {/* <p><strong>Service Status:</strong> {selectedLead.serviceHistory[0].serviceStatus}</p> */}

                                </>
                            ) : (
                                <p>No lead selected.</p>
                            )}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>Close</Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    onClose={handleClickFormClose}
                    aria-labelledby="customized-dialog-title"
                    open={formOpen}
                    sx={{ maxWidth: 700, width: "100%", margin: "0 auto" }}
                >
                    <DialogTitle>
                        <Stepper activeStep={activeStep} alternativeLabel>
                            <Step key="basic">
                                <StepLabel>Basic Info</StepLabel>
                            </Step>
                            {getOrderedServices(selectedServices).map((service, index) => (
                                <Step key={index}>
                                    <StepLabel>{service}</StepLabel>
                                </Step>
                            ))}
                        </Stepper>
                    </DialogTitle>
                    <DialogContent>
                        {activeStep === 0 ? (
                            renderBasicInfoSteps()
                        ) : (
                            renderServiceStep(
                                getOrderedServices(selectedServices)[activeStep - 1]
                            )
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={activeStep === 0 ? () => setFormOpen(false) : handleBack}>
                            {activeStep === 0 ? 'Cancel' : 'Back'}
                        </Button>

                        {!isLastStep() ? (
                            <Button onClick={handleNext} color="primary">
                                Next
                            </Button>
                        ) : (
                            <Button onClick={putService} color="primary">
                                Submit
                            </Button>
                        )}
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={paymentOpen}
                    onClose={handlePaymentClose}
                    aria-labelledby="draggable-dialog-title"
                >
                    <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                        {paymentStatus}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            <TextField
                                label="Total Amount"
                                fullWidth
                                margin="dense"
                                value={totalAmount}
                                onChange={(e) => setTotalAmount(e.target.value)}
                            />
                            {paymentStatus === "Update Payment" && (
                                <TextField
                                    label="Remaining Balance"
                                    fullWidth
                                    margin="dense"
                                    value={remainingBalance}
                                    onChange={(e) => setRemainingBalance(e.target.value)}
                                    disabled
                                />
                            )}
                            <TextField
                                label="Amount Paid"
                                fullWidth
                                margin="dense"
                                value={amountPaid}
                                onChange={(e) => {
                                    setAmountPaid(e.target.value);
                                    if (totalAmount && e.target.value) {
                                        const newRemaining = totalAmount - e.target.value;
                                        setRemainingBalance(newRemaining > 0 ? newRemaining : 0);
                                    }
                                }}
                            />
                            <TextField
                                label="Payment Date"
                                type="date"
                                fullWidth
                                margin="dense"
                                InputLabelProps={{ shrink: true }}
                                value={paymentDate}
                                onChange={(e) => setPaymentDate(e.target.value)}
                            />
                            <TextField margin="dense" select label="Payment Method" value={paymentMethod} onChange={(e) => setPaymentMethod(e.target.value)} fullWidth>
                                {["Cash", "Bank Transfer", "Credit Card", "UPI"].map(p => (
                                    <MenuItem key={p} value={p}>{p}</MenuItem>
                                ))}
                            </TextField>
                            {remainingBalance > 0 && paymentStatus === "Add Payment" && (
                                <TextField
                                    label="Next Payment Date"
                                    type="date"
                                    fullWidth
                                    margin="dense"
                                    InputLabelProps={{ shrink: true }}
                                    value={nextPaymentDate}
                                    onChange={(e) => setNextPaymentDate(e.target.value)}
                                />
                            )}
                            <FormGroup sx={{ marginRight: '50%' }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={gstIncluded}
                                            onChange={(e) => setGstIncluded(e.target.checked)}
                                        />
                                    }
                                    label="GST Including"
                                />
                            </FormGroup>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button autoFocus onClick={handlePaymentClose}>
                            Cancel
                        </Button>
                        <Button onClick={handlePayment}>Submit</Button>

                    </DialogActions>
                </Dialog>
            </Container>
        </>
    )
}

export default ConvertedLeads
